/* eslint-disable consistent-return */
import styled, { css } from 'styled-components';

import { colors, spacing, transitions, typography } from '../../../../styles/theme';
import BaseButton from '../../../ui/Button';

export const Container = styled.div`
  margin-bottom: ${spacing('2')};
`;

export const ItemName = styled.p`
  font-weight: ${typography('weights.semibold')};
  width: 240px;
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
`;

export const Row = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: ${typography('weights.light')};
  padding: ${spacing('2')} 0;
  border-bottom: 1px solid ${colors('black.08')};
`;

export const Actions = styled.div`
  display: flex;
`;

export const Button = styled(BaseButton)`
  min-width: 100px;
  height: 33px;
  padding: 0px;

  &:hover:enabled,
  &:focus:enabled {
    background-color: ${colors('red.base')};
    color: ${colors('white.base')};
  }
`;

// @TODO: Utilizar o componente ButtonStyles.ts
export const Link = styled.a`
  font-size: 14px;
  font-weight: ${typography('weights.semibold')};
  background-color: ${colors('default.base')};
  color: ${colors('black.base')};
  padding: 10px;
  cursor: pointer;
  margin-left: ${spacing('1')};
  border: none;
  border-radius: 24px;
  text-decoration: none;
  font-family: inherit;
  min-width: 100px;
  text-align: center;
  transition: ${transitions('fast')};

  &:not(.disabled-link):hover {
    background-color: ${colors('black.base')};
    color: ${colors('default.base')};
    transition: ${transitions('fast')};
  }

  ${(props) => {
    if (props['aria-disabled']) {
      return css`
        opacity: 0.5;
        cursor: not-allowed;

        :hover,
        :focus {
          background-color: ${colors('default.base')};
          color: ${colors('black.base')};
        }
      `;
    }
  }}
`;
